// extracted by mini-css-extract-plugin
module.exports = {"statCards":"stat-cards-module--stat-cards--2UJs8","statCards__item":"stat-cards-module--stat-cards__item--3Wds7"};